/**
 * Main javascript file of the application
 *
 * @author   pablo.barco
 * @date     2020-06-29
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
 */

import Vue from 'vue'
import { applyPolyfills, defineCustomElements } from 'smtt-ds/loader';
import 'smtt-ds-styles/dist/smtt.css'
import './assets/stylesheet/application.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import getEnv from '@/utils/env';
import VueLazyload from 'vue-lazyload'
import VueMeta from 'vue-meta';
import VueKeyCloakJs from "@/plugins/vue-keycloak";

import App from './App.vue'
import router from './router/router'
import store from './store/store'
import { enterToTabFunction } from "./directives/EnterToTab";
import './utils/firebase';

global.jQuery = require('jquery');
const $ = global.jQuery;
window.$ = $;

Vue.config.productionTip = false

Vue.config.ignoredElements = [ /smtt-\w*/ ];

applyPolyfills().then(() => {
  defineCustomElements();
});

Vue.directive('click-outside', {
  'bind': function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  'unbind': function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})


Vue.directive('enter-to-tab', {
  inserted: function (el) {
    enterToTabFunction(el)
  }
});

const loadimage = require('./assets/images/loading.gif')
const errorimage = require('./assets/images/image-missing.jpg')

Vue.use(VueLazyload, {
  'preLoad': 1.3,
  'error': errorimage,
  'loading': loadimage,
  'attempt': 1
})

Vue.use(VueGoogleMaps, {
  'load': {
    'key': getEnv('VUE_APP_MAP_APIKEY'),
    'libraries': 'places'
  },
  'installComponents': true
})

Vue.use(VueMeta)

if (store.getters.isKeycloakActive()) {
  Vue.use(VueKeyCloakJs, {
    config: {
      url: getEnv('VUE_APP_KEYCLOAK_SERVER'),
      realm: getEnv('VUE_APP_KEYCLOAK_REALM'),
      clientId: getEnv('VUE_APP_KEYCLOAK_CLIENT_ID'),
    },
    init: {
      onLoad: 'check-sso',
      checkLoginIframe: false,
    },
    onReady: async () => {
      new Vue({
        store,
        router,
        'render': (h) => h(App),
      }).$mount('#app')
    },
    onAuthRefreshSuccess: async (keycloak) => {
      // Update the access token from vuex state to use in api calls

      await store.dispatch('updateAccessToken', { 'token': keycloak.token, 'username': keycloak.tokenParsed.preferred_username });
    }
  })
} else {
  new Vue({
    store,
    router,
    'render': (h) => h(App)
  }).$mount('#app')
}
